import {
  getspecificVendor,
  getVendors,
} from "../../store/AsyncMethods/VendorMethod";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RESET_SPECIFIC_CATEGORIES } from "../../store/Types/CategoryTypes";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Icons, toast } from "react-toastify";
import { Divider } from "primereact/divider";

import {
  addCurrency,
  getCurrency,
  getEnableCurrency,
  getspecificCurrency,
  updateCurrency,
} from "../../store/AsyncMethods/CurrencyMethod";
import { SelectButton } from "primereact/selectbutton";
import {
  addCustomers,
  getCustomers,
  getspecificCustomer,
  updateCustomer,
} from "../../store/AsyncMethods/CustomerMethod";
import { Calendar } from "primereact/calendar";
import {
  getSales,
  getspecificSale,
  getUnpaidPostedInvoices,
} from "../../store/AsyncMethods/SalesMethod";
import {
  getPurchase,
  getspecificPurchase,
  getUnpaidPostedPurchases,
} from "../../store/AsyncMethods/PurchaseMethod";
import {
  addPaymentReceipt,
  getspecificPaymentReceipt,
  getPaymentReceipt,
  getVendorBalance,
  updatePaymentReceipt,
  getPendingPurchaseById,
} from "../../store/AsyncMethods/PaymentReceiptMethod";

export default function AddPaymentReceipt() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { specificPaymentReceipt } = useSelector(
    (state) => state.paymentReceipt
  );
  const { customerBalance } = useSelector((state) => state.paymentReceipt);
  const { allCustomers } = useSelector((state) => state.CustomersReducer);
  const { allVendors } = useSelector((state) => state.VendorReducer);
  const { allCurrency } = useSelector((state) => state.CurrencyReducer);
  const { specificSale } = useSelector((state) => state.SalesReducer);
  const { allSales } = useSelector((state) => state.SalesReducer);
  const { unpaidPostedPurchases } = useSelector(
    (state) => state.PurchaseReducer
  );
  const [isDisabled, setIsDisabled] = useState(false);
  const { vendorBalance, pendingPurchases } = useSelector(
    (state) => state.paymentReceipt
  );
  const { specificPurchase } = useSelector((state) => state.PurchaseReducer);
  const { success, error, user } = useSelector((state) => state.AuthReducer);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  // const { specificVendor } = useSelector((state) => state.CustomersReducer);
  const { specificVendor } = useSelector((state) => state.VendorReducer);
  const [selectedTransactionType, setSelectedTransactionType] = useState(1);

  console.log("newone", customerBalance);
  // its just an array to show in drop down
  const receiptTypes = [
    { name: t("Cash"), id: 1 },
    { name: t("Return"), id: 2 },
  ];

  const transactionTypes = [
    { name: "Sales", id: 1 },
    { name: "Purchase", id: 2 },
  ];

  // reset and empty all form fields
  useEffect(() => {
    return () => {
      formik.resetForm();
    };
  }, [location.pathname]);

  //  its get specfic ap payment based on get id, this will set to  "specificPaymentReceipt"
  useEffect(() => {
    if (id) {
      dispatch(getspecificPaymentReceipt(id));
    }
  }, [id]);

  //  if invoice is not selected total must be 0
  useEffect(() => {
    if (!formik.values.invoice) formik.values.total = 0;
  });

  //  formik model all values saves in it
  const formik = useFormik({
    initialValues: {
      receiptType: 1,
      description: "",
      customer: "",
      balance: 0,
      amount: "",
      total: "",
      paidAmount: 0,
      customerOpeningBalance: 0,
      currency: 5,
      invoice: "",
      posted: 0,
      name: "",
      date: new Date(),
      newRemainingAmount: 0,
      originalRemainingAmount: "",
      type: 1,
      transactionType: 1,
    },
    validationSchema: Yup.object({
      // name: Yup.string().required("Name Required"),
      // balance: Yup.string().required("Balance Required"),
      // receiptType: Yup.string().required("Type Required"),
      // date: Yup.string().required("Transaction Date Required"),
      // amount: Yup.string().required("Amount Required"),
      // // currency: Yup.string().required("Currency Required"),
      // invoice: Yup.string().required("Invoice Required"),
    }),

    onSubmit: async (data) => {
      if (id) {
        dispatch(updatePaymentReceipt(data, id)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getPaymentReceipt());
            navigate(
              user?.role_id == 1
                ? "/payment-receipt-main"
                : "/payment-receipt-main"
            );
          }
        });
      } else {
        const submissionData = {
          ...data,
          amount: data.originalRemainingAmount
            ? (
                parseFloat(data.originalRemainingAmount) -
                parseFloat(data.balance)
              ).toString()
            : data.amount,
        };

        dispatch(addPaymentReceipt(submissionData)).then((success) => {
          if (success) {
            formik.resetForm();
          }
        });
      }
    },
  });

  // commented code

  // useEffect(() => {
  //   formik.setValues({
  //     ...formik.values,
  //     description: specificPaymentReceipt.description || "",
  //     customer: specificPaymentReceipt.customer_id || 0,
  //     date: specificPaymentReceipt.date
  //       ? new Date(specificPaymentReceipt.date)
  //       : new Date(),
  //     currency: specificPaymentReceipt.currency_id || 1,
  //     total: specificPaymentReceipt.total || "",
  //     balance: specificPaymentReceipt.amount_received || "",

  //     paidAmount: specificPaymentReceipt.amount_received || 0,
  //     currency: specificPaymentReceipt.currency_id || 1,
  //     invoice: specificPaymentReceipt.sales_id || 0,
  //     posted: specificPaymentReceipt.is_posted || 0,
  //     name: specificPaymentReceipt.customer_name || "",
  //     balance: specificPaymentReceipt.customer_balance || "",
  //   });
  // }, [specificPaymentReceipt]);

  // get data based on specfic ap payment and set into formik
  useEffect(() => {
    if (specificPaymentReceipt) {
      formik.setValues({
        ...formik.values,
        description: specificPaymentReceipt.description || "",
        customer: specificPaymentReceipt.customer_id || 0,
        // Convert string date to Date object
        date: specificPaymentReceipt.date
          ? new Date(specificPaymentReceipt.date)
          : new Date(),
        // Ensure currency_id is a number
        remainingAmount: specificPaymentReceipt.remain_amount,
        currency: Number(specificPaymentReceipt.currency_id) || 5,
        total: pendingPurchases?.total_sale_amount || "",
        balance: specificPaymentReceipt.amount_received || "",
        paidAmount: specificPaymentReceipt.amount_received || 0,
        invoice: specificPaymentReceipt.sales_id || 0,
        posted: specificPaymentReceipt.is_posted || 0,
        name: specificPaymentReceipt.customer_name || "",
        // balance: specificCashReceipt.customer_balance || "",
      });
      if (specificPaymentReceipt.posted === 1) {
        setIsDisabled(true);
      }
    }
  }, [specificPaymentReceipt]);

  // set disabled true if its set to is posted
  useEffect(() => {
    if (formik.values.posted === 1) {
      setIsDisabled(true);
    }
  }, [formik.values.posted]);

  // if get customer balance then set this into specfic field
  useEffect(() => {
    if (customerBalance) {
      formik.setValues({
        ...formik.values,
        customerOpeningBalance: customerBalance.opening_balance || "",
      });
    }
  }, [customerBalance]);

  // check customer is debit or credit
  const filteredCustomers = allVendors.filter(
    (customer) => customer.debit_allowed === 1
  );

  // filter invoices based on its customer or vendor
  const filteredInvoices = unpaidPostedPurchases?.filter(
    (invoice) => invoice.customer_id === formik.values.customer
  );

  // if vendor selected then fill name field
  useEffect(() => {
    if (specificVendor) {
      formik.setValues({
        ...formik.values,
        name: specificVendor.name || "",
      });
    }
  }, [specificVendor]);

  // if customer selected,
  // then filter invoices based on invoice customer id
  //
  useEffect(() => {
    if (formik.values.customer) {
      const customerInvoices = unpaidPostedPurchases?.filter(
        (invoice) => invoice.customer_id === formik.values.customer
      );
      // Set the first matched invoice if needed
      if (customerInvoices?.length > 0) {
        formik.setFieldValue("invoice", customerInvoices[0].id);
      }
    }
  }, [formik.values.customer, allSales]);

  //  useEffect(() => {
  //   debugger
  //   if(id){
  //     if(formik.values.customer){
  //         // formik.setValues("invoice",)
  //         formik.values.invoice = getspecificPaymentReceipt.sales_id
  //     }
  //   }

  // });

  // useEffect(() => {
  //   if(id){
  //     if (formik.values.customer && specificPaymentReceipt) {
  //       formik.values.invoice  = specificPaymentReceipt.sales_id
  //     }
  //   }
  // }, [formik.values.customer,formik.values.invoice,specificPaymentReceipt]);

  // check id not then add case
  // if customer selected then invoice must not be selected
  // user should be choose one of invoice
  useEffect(() => {
    if (!id) {
      if (formik.values.customer) {
        formik.setFieldValue("invoice", "");
      }
    }
  }, [formik.values.customer]);

  // commented code
  // useEffect(() => {
  //   if (selectedTransactionType === 1 && specificSale) {
  //     formik.setValues({
  //       ...formik.values,
  //       amount: specificSale.remain_amount || "",
  //       total: specificSale.total || "",
  //       originalRemainingAmount: specificSale.remain_amount || "",
  //     });
  //   } else if (selectedTransactionType === 2 && specificPurchase) {
  //     formik.setValues({
  //       ...formik.values,
  //       amount: specificPurchase.remain_amount || "",
  //       total: specificPurchase.total || "",
  //       originalRemainingAmount: specificPurchase.remain_amount || "",
  //     });
  //   }
  // }, [specificSale, specificPurchase, selectedTransactionType]);

  // if customer selected then get all vendor
  useEffect(() => {
    if (formik.values.customer)
      dispatch(getspecificVendor(formik.values.customer));
  }, [formik.values.customer]);

  // if invoice selected
  // and purchase invoice id not exsit (means is add case)
  // then get data related to specific invoice
  useEffect(() => {
    if (formik.values.invoice) {
      if (!id) {
        dispatch(getspecificPurchase(formik.values.invoice));
        dispatch(getPendingPurchaseById(formik.values.invoice));
      }
    }
  }, [formik.values.invoice, selectedTransactionType]);

  // if customer or vendor selected
  // then name must be show in disabled field
  useEffect(() => {
    if (specificVendor && formik.values.customer) {
      formik.setFieldValue("name", specificVendor.name || "");
    } else {
      formik.setFieldValue("name", "");
    }
  }, [specificVendor, formik.values.customer]);

  // get all vendors
  // get all currency
  useEffect(() => {
    dispatch(getVendors());
    dispatch(getCurrency());
  }, []);

  // const handleBalanceChange = (e) => {
  //   const balance = parseFloat(e.target.value) || 0;
  //   const originalRemaining =
  //     parseFloat(formik.values.originalRemainingAmount) || 0;

  //   const newRemainingAmount = originalRemaining - balance;

  //   formik.setValues({
  //     ...formik.values,
  //     balance: e.target.value,
  //     amount: newRemainingAmount.toString(),
  //   });
  // };

  // useEffect(() => {
  //   if (specificPurchase) {
  //     if (!id) {
  //       formik.setValues({
  //         ...formik.values,
  //         amount: specificPurchase.remain_amount || "",
  //         total:  pendingPurchases?.total_sale_amount || 0,
  //         originalRemainingAmount: specificPurchase.remain_amount || "",
  //         remainingAmount: specificPurchase.remain_amount || "",
  //         paidAmount: pendingPurchases.amount_received || "",
  //       });
  //     }
  //   }
  // }, [
  //   specificSale,
  //   specificPurchase,
  //   selectedTransactionType,
  //   pendingPurchases,
  //   formik.values.invoice,
  // ]);

  // get remaining amount
  useEffect(() => {
    formik.setFieldValue(
      "remainingAmount",
      formik.values.total - formik.values.balance
    );
  }, [formik.values.balance]);

  // // ap payment id not exist
  // // purchase invoice exist
  // // then set all form values
  // useEffect(() => {
  //   if (!id) {
  //     if (specificPurchase) {
  //       formik.setValues({
  //         ...formik.values,
  //         total: specificPurchase.total ? specificPurchase.total : pendingPurchases?.total_sale_amount  || "",
  //         amount: specificPurchase.remain_amount || "",
  //         remainingAmount: specificPurchase.remain_amount || "",
  //         paidAmount: pendingPurchases?.amount_received || "",
  //       });
  //     }
  //   }
  // }, [specificPurchase, formik.values.invoice]);

  // Handle balance input and update remaining amount
  const handleBalanceChange = (e) => {
    const newBalance = parseFloat(e.target.value) || 0;
    const currentAmount = parseFloat(formik.values.amount) || 0;
    const newRemainingAmount = currentAmount - newBalance;

    formik.setValues({
      ...formik.values,
      balance: e.target.value,
      newRemainingAmount: newRemainingAmount,
    });
  };

  // get customer balance
  // if customer is selected
  useEffect(() => {
    if (formik.values.customer) {
      dispatch(getVendorBalance(formik.values.customer));
    }
  }, [formik.values.customer]);

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {t("AP Payments")}
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="receiptType" className="">
                  {t("Receipt Type")}
                </label>

                <Dropdown
                  id="receiptType"
                  name="receiptType"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.receiptType}
                  onChange={formik.handleChange}
                  options={receiptTypes}
                  disabled={isDisabled}
                  optionLabel="name"
                  optionValue="id"
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.receiptType && formik.errors?.receiptType && (
                <div className="p-error">{formik.errors?.receiptType}</div>
              )}
            </div>

            {/* <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="transactionType" className="">
                  {t("Transaction Type")}
                </label>

                <Dropdown
                  id="transactionType"
                  name="transactionType"
                  className="!w-full text-lg p-primary-input"
                  value={selectedTransactionType}
                  onChange={(e) => {
                    setSelectedTransactionType(e.value);
                    formik.setFieldValue("type", e.value);
                    formik.setFieldValue("invoice", "");
                  }}
                  options={transactionTypes}
                  optionLabel="name"
                  optionValue="id"
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
            </div> */}

            {/* <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="currency" className="">
                  {t("Select Currency")}
                </label>

                <Dropdown
                  id="currency"
                  name="currency"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.currency}
                  onChange={formik.handleChange}
                  options={allCurrency}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.currency && formik.errors?.currency && (
                <div className="p-error">{formik.errors?.currency}</div>
              )}
            </div> */}

            <div className=" ">
              <div className="flex flex-col  gap-2  p-fluid">
                <label htmlFor="date" className="">
                  {t("trans_date")}
                </label>

                <Calendar
                  dateFormat="yy/mm/dd"
                  id="date"
                  onChange={formik.handleChange}
                  className=" w-full calender p-primary-cld-btn"
                  value={formik.values.date}
                  showIcon
                />
              </div>
              {formik.touched?.date && formik.errors?.date && (
                <div className="p-error">{formik.errors?.date}</div>
              )}
            </div>
            <div className=""></div>
            <div className=""></div>
            {/* <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="description" className="">
                  {t("description")}
                </label>
                <span className=" w-full">
                  <InputText
                    id="description"
                    name="description"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.description && formik.errors?.description && (
                <div className="p-error">{formik.errors?.description}</div>
              )}
            </div> */}

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="customer" className="">
                  {t("Select Vendor")}
                </label>

                <Dropdown
                  id="customer"
                  name="customer"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.customer}
                  onChange={formik.handleChange}
                  disabled={isDisabled}
                  options={filteredCustomers}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.customer && formik.errors?.customer && (
                <div className="p-error">{formik.errors?.customer}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="name" className="">
                  {t("Vendor Name")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="name"
                    name="name"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.name && formik.errors?.name && (
                <div className="p-error">{formik.errors?.name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="customerOpeningBalance" className="">
                  {t("Vendor Balance")}
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="customerOpeningBalance"
                    name="customerOpeningBalance"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.customerOpeningBalance}
                    onChange={formik.handleChange}
                    placeholder="0"
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.balance && formik.errors?.balance && (
                <div className="p-error">{formik.errors?.balance}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="invoice" className="">
                  {t("Select Invoice")}
                </label>

                <Dropdown
                  id="invoice"
                  name="invoice"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.invoice}
                  onChange={formik.handleChange}
                  options={filteredInvoices}
                  optionLabel={(option) =>
                    `(${option.id}) - ${new Date(option.created_at)}`
                  }
                  optionValue="id"
                  disabled={isDisabled}
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.invoice && formik.errors?.invoice && (
                <div className="p-error">{formik.errors?.invoice}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="amount" className="">
                  {t("total_amount")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="total_amount"
                    name="total_amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.total}
                    onChange={formik.handleChange}
                    placeholder="0"
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="paidAmount" className="">
                  {t("Paid Amount")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="paid_amount"
                    name="paid_amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.paidAmount}
                    placeholder="0"
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="balance" className="">
                  {t("Amount")} <span className="text-red">*</span>
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="balance"
                    name="balance"
                    className="w-full text-lg p-primary-input"
                    disabled={isDisabled}
                    value={formik.values.balance}
                    placeholder="0"
                    onChange={handleBalanceChange}
                  />
                </span>
              </div>
              {formik.touched?.balance && formik.errors?.balance && (
                <div className="p-error">{formik.errors?.balance}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="remainingAmount" className="">
                  {t("Remaining Amount")}
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="remainingAmount"
                    name="remainingAmount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.remainingAmount}
                    placeholder="0"
                    disabled
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        {isDisabled ? (
          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label={t("GO Back")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {}}
              />
            </div>
          </div>
        ) : (
          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={t(id ? "update" : "submit")}
                icon="pi pi-check"
                className="p-secondary-btn"
                type="submit"
              />
              <Button
                label={t("post")}
                icon="pi pi-check"
                className="p-primary-btn"
                type="submit"
                onClick={() => {
                  formik.values.posted = 1;
                }}
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
}
